var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-layout',[_c('InvestorRelationModal'),_c('page-header',{attrs:{"heading":"Investor Relation","action":"Add","toggle":"offcanvas","target":"#offcanvasCreate","guard":this.$route.meta.guard},on:{"click":_vm.setCreateForm}}),_c('InvestorRelationTable',{attrs:{"tableHeading":_vm.tableHeading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }